module.exports = __webpack_public_path__ + "static/media/logoShearlyCapital512.92021aee.png";